<template>
  <div>
    <ReceiptFlow />
  </div>
</template>
<script>
import ReceiptFlow from '@/components/ReceiptFlow'

export default {
  components: {
    ReceiptFlow
  }  
}
</script>

